import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IContentSetState } from "../states/content-set-state";
import { contentSetService } from "../../services/content-set.service";
import { IContentSet } from "../../models/interfaces/content/content-set.model.interface";
import { StatusType } from "../../enums/StatusType";
import { IContentSetDetailsRequest } from "../../models/interfaces/content/content-set-details-request.model.interface";
import { ContentSetModel } from "../../models/content/content-set.model";
import { IDevice } from "../../models/interfaces/device/device.model.interface";
import { EnquiryType } from "../../enums/EnquiryType";

export const state: IContentSetState = {
    contentSets: [],
    contentSet: new ContentSetModel()
};

export const getters: GetterTree<IContentSetState, RootState> = {
    contentSets(state) {
        return state.contentSets;
    },
    contentSet(state) {
        return state.contentSet;
    }
};

export const mutations: MutationTree<IContentSetState> = {
    contentSets(state, contentSets) {
        state.contentSets = contentSets;
    },
    contentSet(state, contentSet) {
        state.contentSet = contentSet;
    },
    addContentSetDevice(state, device: IDevice) {
        state.contentSet.devices.push(device);
    },
    removeContentSetDevice(state, device: IDevice) {
        state.contentSet.devices = state.contentSet.devices.filter((item) => item.deviceTypeId !== device.deviceTypeId);
    },
    addContentSetEnquiryType(state, enquiryType: EnquiryType) {
        state.contentSet.enquiryTypes.push(enquiryType);
    },
    removeContentSetEnquiryType(state, enquiryType: EnquiryType) {
        state.contentSet.enquiryTypes = state.contentSet.enquiryTypes.filter((item) => item !== enquiryType);
    },
    updateProcess(state, processId: number) {
        state.contentSet.processId = processId;
    },
    updateProductCategory(state, productCategoryId: number) {
        state.contentSet.productCategoryId = productCategoryId;
    }
};

export const actions: ActionTree<IContentSetState, RootState> = {
    async createContentSet({ commit }, contentSet: IContentSet) {
        return new Promise((resolve) => {
            contentSetService.create(contentSet)
                .then((value) => {
                    if (value.success) {
                        commit("contentSet", value.result);
                        resolve(value.success);
                    } else {
                        resolve(false);
                    }
                });
        });
    },
    async retrieveContentSets({ commit }) {
        return new Promise((resolve) => {
            contentSetService.get()
                .then((value) => {
                    commit("contentSets", value.result);
                    resolve(value.success);
                });
        });
    },
    async retrieveContentSet({ commit }, id: number) {
        return new Promise((resolve) => {
            contentSetService.getContentSet(id)
                .then((value) => {
                    commit("contentSet", value.result);
                    resolve(value.success);
                });
        });
    },
    async updateDetails({ commit }, details: IContentSet) {
        return new Promise((resolve) => {
            const request: IContentSetDetailsRequest = {
                name: details.name,
                description: details.description
            };
            contentSetService.updateDetails(details.contentSetId, request).then((value) => {
                resolve(value);
            });
        });
    },
    async deleteContentSet({ commit }, contentSet: IContentSet) {
        return new Promise((resolve) => {
            contentSet.state.statusType = StatusType.Deleted;
            contentSetService.updateState(contentSet.contentSetId, contentSet.state).then((value) => {
                resolve(value);
            });
        });
    },
    async addContentSetDevice({ commit, state }, device: IDevice) {
        return new Promise((resolve) => {
            contentSetService.addContentSetDevice(state.contentSet.contentSetId, device)
                .then((value) => {
                    if (value) {
                        commit("addContentSetDevice", device);
                        resolve(value);
                    }
                });
        });
    },
    async removeContentSetDevice({ commit, dispatch, state }, device: IDevice) {
        return new Promise((resolve) => {
            contentSetService.removeContentSetDevice(state.contentSet.contentSetId, device)
                .then((value) => {
                    if (value) {
                        commit("removeContentSetDevice", device);
                        resolve(value);
                    }
                });
        });
    },
    async addContentSetEnquiryType({ commit, dispatch, state }, enquiryType: EnquiryType) {
        return new Promise((resolve) => {
            contentSetService.addContentSetEnquiryType(state.contentSet.contentSetId, enquiryType)
                .then((value) => {
                    if (value) {
                        commit("addContentSetEnquiryType", enquiryType);
                        resolve(value);
                    }
                });
        });
    },
    async removeContentSetEnquiryType({ commit, state }, enquiryType: EnquiryType) {
        return new Promise((resolve) => {
            contentSetService.removeContentSetEnquiryType(state.contentSet.contentSetId, enquiryType)
                .then((value) => {
                    if (value) {
                        commit("removeContentSetEnquiryType", enquiryType);
                        resolve(value);
                    }
                });
        });
    },
    async updateProcess({ commit, state }, processId: number) {
        return new Promise((resolve) => {
            contentSetService.updateProcess(state.contentSet.contentSetId, processId)
                .then((value) => {
                    if (value) {
                        commit("updateProcess", processId);
                        resolve(value);
                    }
                });
        });
    },
    async updateProductCategory({ commit, state }, productCategoryId: number) {
        return new Promise((resolve) => {
            contentSetService.updateProductCategory(state.contentSet.contentSetId, productCategoryId)
                .then((value) => {
                    if (value) {
                        commit("updateProductCategory", productCategoryId);
                        resolve(value);
                    }
                });
        });
    }
};

export const contentSetModule: Module<IContentSetState, RootState> = {
    state, getters, mutations, actions, namespaced: true
};
